<script setup lang="ts">
defineProps<{
	isLoading?: boolean;
}>();
</script>

<template>
	<div class="flex w-full flex-col gap-6">
		<Skeleton :is-active="true" variant="white" class="h-[22px] w-[182px]" />

		<div class="flex flex-col gap-4 space-y-6">
			<div
				v-for="group in 2"
				:key="`property-features-skeleton-section-group-${group}`"
				class="flex flex-col gap-2 space-y-4"
			>
				<Skeleton :is-active="true" variant="white" class="h-4 w-[100px]" />

				<div class="grid grid-cols-3 gap-y-3">
					<div
						v-for="feature in 13"
						:key="`property-features-skeleton-section-feature-${group}-${feature}`"
						class="flex items-center gap-4"
					>
						<Skeleton
							:is-active="true"
							variant="white"
							class="size-5 min-h-5"
						/>
						<Skeleton
							:is-active="true"
							variant="white"
							class="min-h-3 w-[80px]"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
